import { RadioList, TextInput } from "@milestone/component-library";
import React from "react";
import { Formik, FormikHelpers } from "formik";
import {
  BlueButton,
  OutlineButton,
  SaveButtonContainer,
  StyledForm,
  ColumnContainer,
} from "../../Admin.styles";
import {
  StatusOptions,
  RoleFormType,
  RoleFormSchema,
  RoleFormHeader,
} from "./rolesFormSchema";
import { Header, Section, TopSaveWrapper } from "./rolesForm.styles";
import { useHistory } from "react-router-dom";

interface RoleFormProps {
  header: string;
  submitValues: (
    values: RoleFormType,
    actions: FormikHelpers<RoleFormType>
  ) => void;
  value?: RoleFormType;
  canSave?: boolean;
}

export const RoleForm: React.FC<RoleFormProps> = ({
  header,
  submitValues,
  value,
  canSave = true,
}) => {
  const defaultRoleInfo: RoleFormType = {
    status: StatusOptions[0],
    name: "",
    description: "",
  };

  if (value) {
    if (value.status) defaultRoleInfo.status = value.status;
    if (value.name) defaultRoleInfo.name = value.name;
    if (value.description) defaultRoleInfo.description = value.description;
  }
  const history = useHistory();

  const handleCancel = () => {
    const currentLocation = history.location;
    currentLocation.pathname = "/admin/roles";
    history.push(currentLocation);
  };

  const SaveButtons = (
    <SaveButtonContainer>
      <BlueButton type={canSave ? "submit" : "button"}>Save</BlueButton>
      <OutlineButton type="button" onClick={handleCancel}>
        Cancel
      </OutlineButton>
    </SaveButtonContainer>
  );

  return (
    <ColumnContainer>
      <Formik
        initialValues={defaultRoleInfo}
        validationSchema={RoleFormSchema}
        onSubmit={submitValues}
      >
        {() => (
          <StyledForm>
            <TopSaveWrapper>{SaveButtons}</TopSaveWrapper>
            <Header>{header}</Header>

            <Section>
              {header === RoleFormHeader.edit && (
                <div>
                  <RadioList
                    label="Status"
                    name="status"
                    options={StatusOptions}
                  />
                </div>
              )}

              <TextInput
                name="name"
                label="Role Name"
                placeholder="Role Name"
              />
              <TextInput
                name="description"
                label="Description"
                placeholder="Description"
              />
            </Section>
            {/* {errors && <div>{JSON.stringify(errors)}</div>} */}
          </StyledForm>
        )}
      </Formik>
    </ColumnContainer>
  );
};
